import { IContractorInvestment, IContractorsInvestmentsData } from "@ecp-redux/api/merchantPanel";

export const CONTRACTORS_INVESTMENTS_RESPONSE: IContractorInvestment[] = [
  {
    name1: "Long-Term Growth Investment Strategy",
    name2: "Residential Investment",
    name3: "Growth Strategy",
    investmentType: "residential",
    investmentStage: "tender",
    street: "123 Main Street",
    street2: "Apt 1B",
    houseNo: "123",
    apartmentNo: "1B",
    postCode: "62701",
    city: "Springfield",
    country: "USA",
    province: "IL",
    lastUsed: "2025-01-07T22:59:11.503Z",
    addressLocationImageUrl: "https://placehold.co/278x279",
    id: 1,
  },
  {
    name1: "High Yield Bonds Portfolio",
    name2: "Bonds",
    name3: "Investment",
    investmentType: "residential",
    investmentStage: "inProgress",
    street: "456 Oak Avenue",
    street2: "Suite 300",
    houseNo: "456",
    apartmentNo: "300",
    postCode: "60601",
    city: "Chicago",
    country: "USA",
    province: "IL",
    lastUsed: "2025-01-07T22:59:11.503Z",
    addressLocationImageUrl: "https://placehold.co/278x279",
    id: 2,
  },
  {
    name1: "Tech Startup Equity Investment",
    name2: "Venture Capital",
    name3: "Tech Fund",
    investmentType: "house",
    investmentStage: "tender",
    street: "789 Pine Road",
    houseNo: "789",
    postCode: "10001",
    city: "New York",
    country: "USA",
    province: "NY",
    lastUsed: "2025-01-07T22:59:11.503Z",
    addressLocationImageUrl: "https://placehold.co/278x279",
    id: 3,
  },
  {
    name1: "Global Real Estate Fund",
    investmentType: "industrial",
    investmentStage: "inProgress",
    street: "101 Maple Blvd",
    houseNo: "101",
    postCode: "94110",
    city: "San Francisco",
    country: "USA",
    province: "CA",
    lastUsed: "2025-01-07T22:59:11.503Z",
    id: 4,
  },
  {
    name1: "Sustainable Energy Ventures",
    name2: "Energy",
    name3: "Sustainability",
    investmentType: "residential",
    investmentStage: "tender",
    street: "202 Birch Street",
    houseNo: "202",
    postCode: "73301",
    city: "Austin",
    country: "USA",
    province: "TX",
    lastUsed: "2025-01-07T22:59:11.503Z",
    addressLocationImageUrl: "https://placehold.co/278x279",
    id: 5,
  },
  {
    name1: "Early Stage Venture Capital",
    name3: "Venture Capital",
    investmentType: "commercial",
    investmentStage: "inProgress",
    street: "303 Cedar Lane",
    street2: "Unit 5",
    houseNo: "303",
    apartmentNo: "5",
    postCode: "98101",
    city: "Seattle",
    country: "USA",
    province: "WA",
    lastUsed: "2025-01-07T22:59:11.503Z",
    addressLocationImageUrl: "https://placehold.co/278x279",
    id: 6,
  },
  {
    name1: "Healthcare Innovations Fund",
    name2: "Healthcare",
    name3: "Innovation",
    investmentType: "industrial",
    investmentStage: "tender",
    street: "404 Elm Street",
    houseNo: "404",
    postCode: "90001",
    city: "Los Angeles",
    country: "USA",
    province: "CA",
    lastUsed: "2025-01-07T22:59:11.503Z",
    addressLocationImageUrl: "https://placehold.co/278x279",
    id: 7,
  },
  {
    name1: "Agricultural Investments Portfolio",
    name3: "Agriculture",
    investmentType: "residential",
    investmentStage: "inProgress",
    street: "505 Pine Street",
    houseNo: "505",
    postCode: "75201",
    city: "Dallas",
    country: "USA",
    province: "TX",
    lastUsed: "2025-01-07T22:59:11.503Z",
    id: 8,
  },
  {
    name1: "Private Equity Real Estate",
    name2: "Private Equity",
    name3: "Real Estate",
    investmentType: "commercial",
    investmentStage: "tender",
    street: "606 Fir Avenue",
    houseNo: "606",
    postCode: "33101",
    city: "Miami",
    country: "USA",
    province: "FL",
    lastUsed: "2025-01-07T22:59:11.503Z",
    addressLocationImageUrl: "https://placehold.co/278x279",
    id: 9,
  },
  {
    name1: "Luxury Goods Growth Fund",
    name3: "Luxury Goods",
    investmentType: "industrial",
    investmentStage: "inProgress",
    street: "707 Ash Blvd",
    street2: "Building 4",
    houseNo: "707",
    apartmentNo: "4",
    postCode: "80202",
    city: "Denver",
    country: "USA",
    province: "CO",
    lastUsed: "2025-01-07T22:59:11.503Z",
    addressLocationImageUrl: "https://placehold.co/278x279",
    id: 10,
  },
];


export const SELECTED_INVESTMENTS_RESPONSE: IContractorsInvestmentsData = {
  defaultInvestment: {
    id: 1,
    name: "Default Investment",
    apartmentNo: "A101",
    city: "New York",
    country: "USA",
    houseNo: "123",
    postCode: "10001",
    province: "NY",
    street: "5th Avenue",
    street2: "Suite 202",
  },
  selectedInvestment: {
    id: 2,
    name: "Selected Invest with a long name and additional info about the address",
    apartmentNo: "B202",
    city: "Los Angeles",
    country: "USA",
    houseNo: "456",
    postCode: "90001",
    province: "CA",
    street: "Sunset Boulevard",
    street2: "Floor 3",
  },
  investments: [
    {
      id: 3,
      name: "Investment 1 with a long name and additional info about the address",
      apartmentNo: "C303",
      city: "Chicago",
      country: "USA",
      houseNo: "789",
      postCode: "60601",
      province: "IL",
      street: "Michigan Avenue",
      street2: "Unit 1",
    },
    {
      id: 4,
      name: "Investment 2",
      apartmentNo: "D404",
      city: "San Francisco",
      country: "USA",
      houseNo: "101",
      postCode: "94101",
      province: "CA",
      street: "Market Street",
      street2: "Room 501",
    },
    {
      id: 5,
      name: "Investment 3",
      apartmentNo: "E505",
      city: "Miami",
      country: "USA",
      houseNo: "202",
      postCode: "33101",
      province: "FL",
      street: "Ocean Drive",
      street2: "Suite 102",
    },
    {
      id: 6,
      name: "Investment 4",
      apartmentNo: "F606",
      city: "Dallas",
      country: "USA",
      houseNo: "303",
      postCode: "75201",
      province: "TX",
      street: "Elm Street",
      street2: "Penthouse 1",
    },
  ],
};